// extracted by mini-css-extract-plugin
export var bodyRow = "_fm-d";
export var cardColumns = "_fm-e";
export var ellipsesOverflow = "_fm-2";
export var flatBottomCorners = "_fm-3";
export var flatTopCorners = "_fm-4";
export var headerActionsDropdown = "_fm-f";
export var headerBottomRow = "_fm-c";
export var headerTopRow = "_fm-b";
export var orderDetailsWrapper = "_fm-0";
export var orderInfoContainer = "_fm-1";
export var productDetails = "_fm-9";
export var productImage = "_fm-5";
export var responsiveTable = "_fm-8";
export var shipmentContainer = "_fm-a";
export var tableBottomLeft = "_fm-6";
export var tableBottomRight = "_fm-7";